import { queryOptions } from "@tanstack/react-query";
import type { Capabilities } from "@/app/capabilities/types";
import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { capabilitiesKeys } from "./query-keys";

export const fetchCapabilities = async (
  scope: OrgProjectScope
): Promise<Capabilities> => {
  const client = getCoordinatorApi(scope);
  const { data } = await client.get<Capabilities>("/capabilities");
  return data;
};

export const capabilitiesQueryOptions = (scope: OrgProjectScope) =>
  queryOptions<Capabilities>({
    queryKey: capabilitiesKeys.all({ scope }),
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: () => fetchCapabilities(scope),
  });
